import classNames from 'classnames'
import Link from 'next/link'
import { useState } from 'react'
import { ReactNode } from 'react'
import BSCard from 'react-bootstrap/Card'

import Card from '@/components/Card/Card'
import Icon from '@/components/Icon/Icon'
import { CardLabelVariantType, GenericCardType } from '@/types/card'
import { useCard } from '@/utils/fetcher'
import { formatUrl } from '@/utils/helpers'

import styles from './CardHover.module.scss'

type Props = {
  card?: GenericCardType
  children?: ReactNode | undefined
  collectorNumber?: string
  isPreview?: boolean
  labelVariant?: CardLabelVariantType
  left?: boolean
  mobileOnly?: boolean
  name?: string
  onlyBack?: boolean
  onlyFront?: boolean
  reverse?: boolean
  setCode?: string
  sideBySide?: boolean
  target?: string
  url?: string
}

const CardHover = (props: Props) => {
  const [isHovering, setIsHovering] = useState(false)
  const [mobileViewerIsOpen, setMobileViewerIsOpen] = useState(false)

  const { children, left, mobileOnly, target, ...cardProps } = props
  let { name, url } = props

  if (cardProps.card) name = cardProps.card.name
  const childrenOrName = children || name

  // Fetch data
  const { data, error } = useCard({ name: name as string })

  if (cardProps.card?.url) {
    url = cardProps.card.url
  } else if (!url) {
    url = `/${data?.legal_commander ? 'commanders' : 'cards'}/${formatUrl((name as string).split('|')[0])}`
  }

  return (
    <>
      <span
        className={classNames(`d-none d-md-inline`, {
          [styles.error]: cardProps.isPreview && error,
          [styles.typo]: cardProps.isPreview && data?.typo && !error,
        })}
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
      >
        <span>
          {url ? (
            <Link href={url} target={target}>
              {childrenOrName}
            </Link>
          ) : (
            childrenOrName
          )}
        </span>
        {isHovering && !mobileOnly ? (
          <span
            className={classNames(
              styles.hover,
              { [styles.left]: left, [styles.sideBySide]: cardProps.sideBySide },
              'shadow-sm',
            )}
          >
            <BSCard>
              <Card background name={name} {...cardProps} labelVariant={props?.labelVariant} />
            </BSCard>
          </span>
        ) : null}
      </span>
      <span className='d-inline d-md-none'>
        <span className='fake-link' onClick={() => setMobileViewerIsOpen(true)}>
          {childrenOrName}
        </span>
        {mobileViewerIsOpen && (
          <div className={styles.mobileViewer} onClick={() => setMobileViewerIsOpen(false)}>
            <div className='align-items-end d-flex flex-column'>
              <div className='position-relative'>
                <Icon className={classNames(styles.close, 'cursor-pointer text-danger')} icon='times' size='xl' />
              </div>
              <div onClick={(event) => event.stopPropagation()}>
                <Card background name={name} {...cardProps} />
              </div>
            </div>
          </div>
        )}
      </span>
    </>
  )
}

export default CardHover
